export default "__VITE_ASSET__CRaGrVqN__"